
import React, { useContext } from "react";
import { AuthContext } from '../store/ContextStore';

type ButtonProps ={
    icon:string | "",
    color:string | "",
    type:string | "",
    size:string | "",
    iconAllignment:string | "",
    text:string,
    isDisabled:boolean
    handleButtonClick:any
}

function Button(props:ButtonProps) {
    const {icon, iconAllignment, text, isDisabled, handleButtonClick} = props || {}
    const {team} = useContext(AuthContext)
  return (
    <button disabled={isDisabled} className={`bg-white font-primary font-semibold text-base text-wrap border rounded-[10px] px-[18px] py-[17px] flex flex-row gap-2 hover:cursor-pointer hover:shadow-custom 
      ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
    style={{  // Static background color
      color: isDisabled?"#D3D3D3":team.colorCode,           // Dynamic text color
      borderColor: isDisabled?"#D3D3D3":team.colorCode,     // Dynamic border color
    }}
    onClick={handleButtonClick}
    >
        {iconAllignment === "left"?<img src={icon} alt="button icon"/>:""}
        {text}
        {iconAllignment === "right"?<img src={icon} alt="button icon"/>:""}
    </button>
  )
}

export default Button